import React, { useMemo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { buildCategoryProgramMap } from 'modules/OpenPrograms/utils'
import { flattenResponse } from 'utils/helpers'
import { useLocalize } from 'utils/localize'

import Entry from './Entry'
import { TabPanel, Tabs } from 'ui/elements/Tabs'
import Carousel from 'ui/elements/Carousel'
import Heading from 'ui/elements/Heading'

export const query = graphql`
  fragment ReadProgramsSummary on Query {
    ProgramsSummaryCategories: allSanityCategories(sort: [{ title: ASC }]) {
      edges {
        node {
          title
          id
        }
      }
    }

    ProgramsSummaryPrograms: allSanityProgram(
      filter: { disabled: { ne: true }, hidden: { ne: true } }
    ) {
      edges {
        node {
          ...ProgramEntry
        }
      }
    }
  }
`

const ProgramsSummary: React.FC<{
  data: Pick<
    Queries.ReadProgramsSummaryFragment,
    'ProgramsSummaryCategories' | 'ProgramsSummaryPrograms'
  >
}> = ({ data }) => {
  const categories = useMemo(() => {
    return data.ProgramsSummaryCategories.edges.map((e) => e.node)
  }, [])

  const _programs = useMemo(() => {
    return data.ProgramsSummaryPrograms.edges.map((e) => e.node)
  }, [data])

  const programs = useLocalize(_programs)

  const entries = useMemo(() => {
    return buildCategoryProgramMap(categories, programs)
  }, [categories, programs])

  return (
    <Tabs>
      {entries.map((entry) => (
        // @ts-ignore
        <TabPanel label={entry.title} key={entry.id}>
          <Heading level={2} hidden>
            {entry.title}
          </Heading>
          {/*@ts-ignore*/}
          <Carousel
            responsive={{
              xs: { items: 1 },
              sm: { items: 2 },
              md: { items: 2 },
              lg: { items: 2 },
            }}
          >
            {entry.programs.map((program) => (
              <Entry key={program.id} program={program} />
            ))}
          </Carousel>
        </TabPanel>
      ))}
    </Tabs>
  )
}

export default ProgramsSummary
